export default __webpack_public_path__ + "static/Tek_Canteen-f837eb8a1f8f5172e75030c24054ce98.png";